import React from 'react';
import Uganda_baby3 from './uganda_baby3';
import Uganda_baby3_subjects from './uganda_baby3_subjects';
const Uganda_baby3soc = () => {
  return (
    <div>
      <Uganda_baby3 />
    <Uganda_baby3_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Social Studies</h1>
      <h3>Social studies content</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in social studies learning and assessment </li>
      <li>Cross-cutting isues integrated in social studies learning and assessment </li>
      <li>Values integrated in social studies learning and assessment </li>
      </div>
    </div>
  );
}

export default Uganda_baby3soc;

